export const CustomerDetailNames = {
  M13_PERKS_2025: '2025m13perks',
};
